import React, { useState, useContext, useEffect } from "react";
import { NavLink, Link, withRouter, useHistory } from "react-router-dom";
import Dropdown from 'react-bootstrap/Dropdown';
import Badge from 'react-bootstrap/Badge';
import axios from "axios";
//base url
import { BASE_URL } from "../../BaseUrl";
import { confirmAlert } from "react-confirm-alert";
import { FaMessage } from "react-icons/fa6";
// //media css
// import "./navmedia.css";

//pages, functions
import {
  _t,
  getCookie,
  deleteCookie,
  getSystemSettings,
  checkPermission,
  checkNetworkStatus,
  isTimeExpired,
  setApiTime
} from "../../functions/Functions";
import { useCustomHooks } from "../../functions/Hooks";

//context consumer
import { SettingsContext } from "../../contexts/Settings";
import { UserContext } from "../../contexts/User";
import { FoodContext } from "../../contexts/Food";

//3rd party packages
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Navbar = (props) => {

  const { firebaseAuth, playNotificationSound, firebaseAuthSetData } = useCustomHooks();
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const [isOnline, setIsOnline] = useState(true);

  //check if Online helper
  const Online = () => {
    return isOnline;
  };

  useEffect(() => {
    const checkIfOffline = async () => {
      const isOffline = await checkNetworkStatus();
      setIsOnline(isOffline);
    };
    checkIfOffline();
  }, []);

  //getting context values here
  let { navLanguageList, navCurrencyList, generalSettings } = useContext(SettingsContext);
  let { authUserInfo } = useContext(UserContext);
  
  let {
    setLoading,
    //food group
    foodGroupForSearch,
  } = useContext(FoodContext);

  // States hook  here
  const [defaultLang, setDefaultLang] = useState(null);
  const [defaultCurrency, setDefaultCurrency] = useState(null);
  const [isFullscreen, setIsFullscreen] = useState(document.fullscreenElement != null);
  
  const handleResize = () => {
    if (isFullscreen) {
      // if (document.fullscreenElement) {
      //   const viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
      //   document.documentElement.style.height = `${viewportHeight}px`;
      // }
      const activeElement = document.activeElement;
      if (activeElement && (activeElement.tagName.toUpperCase() === 'INPUT' || activeElement.tagName.toUpperCase() === 'SELECT' || activeElement.classList.contains('css-b62m3t-container'))) {
        const elementRect = activeElement.getBoundingClientRect();
        const viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
        if ((elementRect.top > viewportHeight) && viewportHeight / 2) {
          activeElement.scrollIntoView({ behavior: 'smooth', block: 'end', inline: "nearest" });
        } else {
          activeElement.scrollIntoView({ behavior: 'smooth', block: 'center', inline: "nearest" });
        }
      }
    }
  };

  useEffect(() => {

    const handleFullscreenChange = () => {     
      if (document.fullscreenElement) {
        setIsFullscreen(true);
      } else {
        setIsFullscreen(false);
      }
    };

    window.visualViewport.addEventListener('resize', handleResize);
    document.addEventListener('fullscreenchange', handleFullscreenChange);

    return () => {
      window.visualViewport.removeEventListener('resize', handleResize);
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
    };
  }, [isFullscreen]);

  useEffect(() => {
    handleOnLoadDefaultLang();
    handleOnLoadDefaultCurrency();
  }, [navLanguageList, navCurrencyList]);

  //set default language on site load
  const handleOnLoadDefaultLang = () => {
    let localLang = localStorage.i18nextLng;
    if (localLang) {
      if (localLang === undefined || localLang.includes("en-")) {
        navLanguageList &&
          navLanguageList.map((item) => {
            if (item.is_default === true) {
              i18n.changeLanguage(item.code);
              setDefaultLang(item);
            }
            return true;
          });
      } else {
        const temp =
          navLanguageList &&
          navLanguageList.find((item) => {
            return item.code === localLang;
          });
        setDefaultLang(temp);
        i18n.changeLanguage(localLang);
      }
    }
  };

  //change language to selected
  const handleDefaultLang = (lang) => {
    i18n.changeLanguage(lang.code);
    setDefaultLang(lang);
    toast.success(`${_t(t("Language has been switched!"))}`, {
      position: "bottom-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      className: "text-center toast-notification",
    });
  };

  //set default currency on site load
  const handleOnLoadDefaultCurrency = () => {
    let localCurrency = JSON.parse(localStorage.getItem("currency"));
    if (localCurrency === null) {
      navCurrencyList &&
        navCurrencyList.map((item) => {
          if (item.is_default === true) {
            setDefaultCurrency(item);
            localStorage.setItem("currency", JSON.stringify(item));
          }
          return true;
        });
    } else {
      const temp =
        navCurrencyList &&
        navCurrencyList.find((item) => {
          return item.code === localCurrency.code;
        });
      setDefaultCurrency(temp);
    }
  };

  //change currency to selected
  const handleDefaultCurrency = (item) => {
    setLoading(true);
    localStorage.setItem("currency", JSON.stringify(item));
    setDefaultCurrency(item);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
    toast.success(`${_t(t("Currency has been changed!"))}`, {
      position: "bottom-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      className: "text-center toast-notification",
    });
  };
   
  //logout
  const handleLogout = async(network = null) => {
    let checkOffline = true;
    if(network === null){
      checkOffline = await checkNetworkStatus();
    }
    if(!checkOffline){
      history.push("/");
    }
    deleteCookie();
  };

  const handlePasscode = () =>{
    const url = BASE_URL + "/settings/new-passcode";
    let formData = {
      id:authUserInfo.details?.id,
      name:authUserInfo.details?.name,
      branch_id: authUserInfo.details?.branch_id,
    }
    return axios
    .post(url, formData)
    .then((res) => {
      handleManagerPasscode(res)
    })
    .catch((error) => {
      toast.error("Please try again")
    })
  }

  const handleRemovePasscode = (onClose) =>{
    const url = BASE_URL + "/settings/delete-passcode";
    let formData = {
      id:authUserInfo.details?.id,
      branch_id: authUserInfo.details?.branch_id,
    }
    return axios
    .post(url, formData)
    .then((res) => {
      if(res.data){
        toast.success(`${_t(t("Passcode removed successfully!"))}`, {
          position: "bottom-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        if (onClose) onClose();
      }
    })
    .catch((error) => {
      toast.error("Please try again")
    })
  }

   //manager passcode
   const handleManagerPasscode = (res) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="card shadow-sm border-0 rounded-lg p-4" style={{ maxWidth: '400px', margin: '0 auto', backgroundColor: '#fff' }}>
            <div className="text-center mb-2">
              <h4 className="font-weight-bold mb-1" style={{ color: '#333' }}>Manager Passcode</h4>
              <p className="text-muted small">Use this passcode for manager access</p>
            </div>
            
            <div className="bg-light rounded py-3 px-2 mb-4 text-center position-relative border cursor-pointer" onClick={() => {
              navigator.clipboard.writeText(res.data);
              toast.success("Passcode copied to clipboard", {
                position: "bottom-center",
                autoClose: 2000,
                hideProgressBar: true,
                className: "text-center",
              });
            }}>
              <span className="d-block font-weight-bold mb-2 xxxslg-text text-primary" style={{ letterSpacing: '3px' }}>
                {res.data}
              </span>
              <div className="text-muted small d-flex align-items-center justify-content-center">
                <i className="fa fa-copy mr-2"></i> Click to copy
              </div>
            </div>

            <div className="d-flex justify-content-center mt-3">
              <button className="btn btn-danger px-4 py-2 rounded-pill mr-3" onClick={() => handleRemovePasscode(onClose)}>
                <i className="fa fa-trash mr-2"></i> {_t(t("Remove Passcode"))}
              </button>
              <button className="btn btn-secondary px-4 py-2 rounded-pill" onClick={onClose}>
                {_t(t("Close"))}
              </button>
            </div>
          </div>
        );
      },
    });
  };

  //flush cache
  const handleFlushCache = async() => {
    const url = BASE_URL + "/settings/flush-cache"
    try {
      const res = await axios.post(url, {}, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      if(res && res.data){
        toast.success(`${_t(t("Cache flushed!"))}`,{
          position: "bottom-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        })
      }
    } catch {
    }
  }

  // clear cache
  const handleClearCache = async() => {
    let checkOffline = await checkNetworkStatus();
    if(!checkOffline){
      await handleLogout(checkOffline);
    }else{
      localStorage.clear();
      sessionStorage.clear();
      await handleLogout(checkOffline)
    }
  }

  //dynamic style
  const style = {
    logo: {
      backgroundColor: generalSettings &&
        getSystemSettings(generalSettings, "type_background"),
      backgroundImage: generalSettings &&
        `url(${getSystemSettings(generalSettings, "type_logo")})`,
    },
    currency: {
      backgroundColor: generalSettings && getSystemSettings(generalSettings, "type_clock"),
      color: generalSettings && getSystemSettings(generalSettings, "type_color"),
    },
  };

  const [stock,setStock]=useState([]);
  const [showNotify,setShowNotify] = useState(false);
  const [showBadge, setShowBadge] = useState(false);
  const [showReqBadge, setShowReqBadge] = useState(false);
  const [showStock, setShowStock] = useState(null);
  const [preOrderCount, setPreOrderCount] = useState(0);
  const [blinkConfig, setBlinkConfig] = useState({ show: false, blink: false });
  const [blinkStock, setBlinkStock] = useState({ loading: false, data: null });
  
  //store req notify firebase and api
  const fetchStockReq = (user) => {   
    let stockRef = 'pos/' + getSystemSettings(generalSettings, "firebase_collection") + '/store_req';
    if(user?.branch_id){
      stockRef += '/' + user.branch_id;
    }
    return firebaseAuth(stockRef, (error, data) => {
      if (error) {
        console.error("Firebase Error:", error);
        return;
      }
      if(data){
        if(data){
          let res = [];
          let bellRingNotify = null;
          let targetUrl = stockRef;

          const list = user?.branch_id 
            ? [data] 
            : (Array.isArray(data) ? data : Object.values(data));

          for (const item of list) {
            if (item && item.message !== "issued") {
              res.push(item);
              if (!bellRingNotify && item.is_bell == 1) {
                bellRingNotify = { ...item, is_bell: 0 };
                
                if (!user?.branch_id) {
                  const key = Object.keys(data).find(k => data[k] === item);
                  targetUrl = stockRef + "/" + key;
                }
              }
            }
          }

          console.log("abcd8", res, user, data);

          if (res.length > 0) {
            setShowReqBadge(true);
            setShowStock(res);
            
            if (bellRingNotify) {
              playNotificationSound();
              if(targetUrl){
                setTimeout(() => {
                  firebaseAuthSetData(targetUrl, bellRingNotify);
                }, 5000);
              }
            }
          }
        }
      }
    })
  }

  //stock notify firebase and api
  const fetchStockQty = () => {    
    const itemStockRef = 'pos/' + getSystemSettings(generalSettings, "firebase_collection") + '/raw_material';

    return firebaseAuth(itemStockRef, (error, data) => {
      if (error) {
        console.error("Firebase Error:", error);
        return;
      }
      if(data){
        getStockData();
      }
    })
  } 

  //firbase pre order
  const getFirbasePreOrder = () =>{
    let url = "pos/" + getSystemSettings(generalSettings, "firebase_collection") + "/today_pre_orders";
    if(authUserInfo.details?.user_type === "staff" || authUserInfo.details?.user_type === "manager"){
      url = "pos/" + getSystemSettings(generalSettings, "firebase_collection") + "/today_pre_orders/" + authUserInfo?.details?.branch_id
    }
    
    return firebaseAuth(url, (error, res) => {
      if (error) {
        console.error("Firebase Error:", error);
        return;
      }
      if(res){
        if(authUserInfo.details.user_type === "staff" || authUserInfo.details.user_type === "manager"){
          if(res?.message === "Notified"){
            setPreOrderCount(res.total_orders)
          }
        }else{
          // Loop through the objects
          for (const key in res) {
            if (res[key]?.message === "Notified") {
              setPreOrderCount(res[key].total_orders)
              break;
            }
          }
        }
      }
    })
  };

  //firbase blink
  const getFirebaseBlink = () => {
    const url = "pos/" + getSystemSettings(generalSettings, "firebase_collection") + "/blink/" + authUserInfo?.details?.branch_id;
    return firebaseAuth(url, (error, res) => {
      console.log("abcd8",res)
      if (error) {
        console.error("Firebase Blink Error:", error);
        return;
      }
      if (res) {
        const message = res?.data?.message || res?.message;
        if (message === "Notified") {
          setBlinkConfig({ show: true, blink: true });
        }
      }
    });
  };

  const fetchBlinkStocks = async () => {
    setBlinkConfig(prev => ({ ...prev, blink: false }));
    setBlinkStock(prev => ({ ...prev, loading: !prev.data }));
    try {
      const url = BASE_URL + "/settings/show-stocks?branch_id=" + authUserInfo?.details?.branch_id;
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      if (response?.data?.status === "success") {
        setBlinkStock({ loading: false, data: response.data.data });
      } else {
        setBlinkStock(prev => ({ ...prev, loading: false }));
      }
    } catch (error) {
      console.error("Error fetching blink stocks:", error);
      setBlinkStock(prev => ({ ...prev, loading: false }));
    }
  };

  useEffect(() => {
    if(!authUserInfo?.details || !getCookie()) return;
    let preOrderUnsub;
    let stockReqUnsub;
    let blinkUnsub;

    if (authUserInfo?.details && getCookie()) {
      if(authUserInfo?.details?.user_type !== "call_center"){
        preOrderUnsub = getFirbasePreOrder();
      }
      stockReqUnsub = fetchStockReq(authUserInfo.details);

      const userType = authUserInfo?.details?.user_type;
      if (userType !== "superAdmin" && userType !== "admin" && userType !== "multi_manager") {
        blinkUnsub = getFirebaseBlink();
      }
    }

    return () => {
      if (preOrderUnsub) {
        preOrderUnsub.then(unsub => {
          if (typeof unsub === "function") unsub();
        });
      }
      if (stockReqUnsub) {
        stockReqUnsub.then(unsub => {
          if (typeof unsub === "function") unsub();
        });
      }
      if (blinkUnsub) {
        blinkUnsub.then(unsub => {
          if (typeof unsub === "function") unsub();
        });
      }
    };
  }, [authUserInfo?.details]);

  const handleQB = () => {
    const url = BASE_URL + '/settings/QB-Connecting'; 
    return axios
    .get(url, {
      headers: { Authorization: `Bearer ${getCookie()}` },
    })
    .then((res) => {
      setLoading(false);
      toast.success(`${_t(t(res.data?.message))}`, {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    })
    .catch((err) => {
      toast.error(`${_t(t(err.response.data?.message))}`, {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
      setLoading(false)
    })
  }

  const getStockData = async () => {      
    const url = BASE_URL + "/settings/get-low-stock-items"
    try {
      const res = await axios
      .get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      if(res && res.data){
        setShowNotify(true);
        if(res.data.length > 0){
          setShowBadge(true);
        }
        res.data.sort((a,b)=>a.stockQty-b.stockQty);
        setStock(res.data)
      }
    } catch {
    }
  }

  // fullscreen and back
  const fullExitScreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch((err) => {
        console.log(`${err.message} : (${err.name})`);
      });
    } else {
      document.exitFullscreen().catch((err) => {
        console.log(`${err.message} : (${err.name})`);
      });
    }
  };
  
  return (
    <>
      {props.location.pathname !== "/" &&
        props.location.pathname !== "/profile" &&
        props.location.pathname !== "/profile/" &&
        props.location.pathname !== "/my-orders" &&
        !props.location.pathname.startsWith("/digital-menu") &&
        props.location.pathname !== "/login" &&
        props.location.pathname !== "/login/" &&
        props.location.pathname !== "/sign-up" &&
        props.location.pathname !== "/sign-up/" &&
        props.location.pathname !== "/delivery-man-registration" &&
        props.location.pathname !== "/delivery-man-registration/" &&
        props.location.pathname !== "/installation" &&
        props.location.pathname !== "/installation/" &&
        props.location.pathname !== "/installation/permission-chcek" &&
        props.location.pathname !== "/installation/permission-chcek/" &&
        props.location.pathname !== "/installation/database-setup" &&
        props.location.pathname !== "/installation/database-setup/" &&
        props.location.pathname !== "/installation/import-database" &&
        props.location.pathname !== "/installation/import-database/" &&
        props.location.pathname !== "/installation/add-admin-user" &&
        props.location.pathname !== "/installation/add-admin-user/" &&
        props.location.pathname !== "/installation/congratulation" &&
        props.location.pathname !== "/installation/congratulation/" &&
        props.location.pathname !== "/dashboard/pos" &&
        props.location.pathname !== "/dashboard/pos/" &&
        props.location.pathname !== "/reset-password" &&
        props.location.pathname !== "/reset-password/" &&
        props.location.pathname !== "/sales-listing" &&
        !props.location.pathname.includes("/feedback/") &&
        !props.location.pathname.includes("/order-details/") &&
        !props.location.pathname.includes("/set-new-password") ? (
        <header key={1} id="header" className="sticky-top pos-header">
          <div
            className={`${props.location.pathname.includes("/dashboard/kitchen") ||
              props.location.pathname.includes("/dashboard/orders") ||
              props.location.pathname.includes("/dashboard/online-orders")
              ? "container-fluid"
              : "container-fluid"
              }`}
          >
            <div className="row align-items-center">
              <div className="col-6 col-lg-2">
                <div className="fk-brand fk-brand--sr-lg">
                  {getCookie() !== undefined || isOnline
                    ? [
                      window.location.pathname === "/dashboard" ? (
                        <NavLink
                        to={{ pathname: "/refresh", state: "/dashboard" }}
                        exact
                        className="t-link w-100"
                        key="logokey"
                        >
                          <span
                            className="fk-brand__img fk-brand__img--fk"
                            style={style.logo}
                          ></span>
                        </NavLink>
                      ) : (
                        <NavLink
                          to="/dashboard"
                          exact
                          className="t-link w-100"
                          key="logokey"
                        >
                          <span
                            className="fk-brand__img fk-brand__img--fk"
                            style={style.logo}
                          ></span>
                        </NavLink>
                      ),
                    ]
                    : [
                      window.location.pathname === "/" ? (
                        <NavLink
                          to={{ pathname: "/refresh", state: "/" }}
                          exact
                          className="t-link w-100"
                        >

                          <span
                            className="fk-brand__img fk-brand__img--fk"
                            style={style.logo}
                          ></span>
                        </NavLink>
                      ) : (
                        <NavLink to="/" exact className="t-link w-100">
                          <span
                            className="fk-brand__img fk-brand__img--fk"
                            style={style.logo}
                          ></span>
                        </NavLink>
                      ),
                    ]}
                </div>
              </div>

              <div className="col-6 col-lg-8 col-xl-8 col-xxl-8 ml-lg-auto">
                <div className="fk-phn-nav text-right d-lg-none">
                  <span className="fk-phn-nav__icon xlg-text">
                    <i className="fa fa-bars"></i>
                  </span>
                </div>
                <div className="fk-phn-nav__menu">
                  <ul className="t-list config-list d-flex flex-column flex-sm-row align-items-sm-center flex-wrap justify-content-md-center justify-content-lg-between justify-content-xl-end">

                    <li className="config-list__item shortcuts">
                      <button title="Full screen" className="text-capitalize sm-text nav-link pl-2 bg-transparent border-0" onClick={()=>fullExitScreen()}>
                        
                        {isFullscreen ? <img src={'/assets/img/full-screen-pos-icon.svg'} alt="minimize" style={{width:"24px", height:"24px"}} />
                          : <img src={'/assets/img/full-screen-pos-icon.svg'} alt="maximize" style={{width:"24px", height:"24px"}} />
                        }
                       
                      </button>
                    </li>

                    {blinkConfig.show && <li className="config-list__item shortcuts">
                      <Dropdown className="stock-notify-dropdown" onToggle={(isOpen) => {
                        if(isOpen) fetchBlinkStocks();
                      }}>
                        {blinkConfig.blink && <p className="stock-notify-badge">
                          <Badge bg="warning" text="white">!</Badge>
                        </p>}
                        <Dropdown.Toggle title="Low Stock" variant="transparent" className="custom-toggle" id="dropdown-blink">
                          <i className={`fa fa-exclamation-triangle ${blinkConfig.blink ? 'modern-icon-blink' : ''}`} style={{fontSize:"20px",color: blinkConfig.blink ? "#e74c3c" : "#0a8d6e"}} aria-hidden="true"></i>
                        </Dropdown.Toggle>

                        <Dropdown.Menu className="stock-notify-dropdown-menu">
                          {blinkStock.data ?
                            Object.keys(blinkStock.data).map((branchName) => {
                              return blinkStock.data[branchName].map((item, index) => (
                                <Dropdown.Item key={`${branchName}-${index}`} className="stock-notify-dropdown-list" disabled>
                                  <div style={{ fontSize: "13px" }}>
                                    <div className="stock-notify-dropdown-item stock-items-green">
                                      <span className="text-truncate">
                                        <i className="fa fa-info-circle mr-1" style={{ pointerEvents: 'auto', cursor: 'help' }} title="Note: Item quantity is in base quantity" aria-hidden="true"></i>
                                        <strong>Item:</strong> {item.item_name}
                                      </span>
                                      <span className="text-preline"><strong>Stock:</strong> {item.current_stock}</span>
                                      <span className="text-preline"><strong>Min Limit:</strong> {item.min_limit_qty}</span>
                                    </div>
                                  </div>
                                </Dropdown.Item>
                              ))
                            })
                           : blinkStock.loading ? (
                             <Dropdown.Item disabled>Loading...</Dropdown.Item>
                           ) : <Dropdown.Item disabled>No Data</Dropdown.Item>} 
                        </Dropdown.Menu>
                      </Dropdown>
                    </li>}

                    <li className="config-list__item shortcuts">
                      <Dropdown className="stock-notify-dropdown" onToggle={()=>setShowReqBadge(false)}>
                        {showReqBadge && <p className="stock-notify-badge">
                          <Badge bg="btn-success">{showStock && (Array.isArray(showStock) ? showStock.length : 1)}</Badge>
                        </p>}
                        <Dropdown.Toggle title="stock request" variant="transparent" className="custom-toggle" id="dropdown-basic">
                          <FaMessage style={{fontSize:"18px",color: "#0a8d6e"}} aria-hidden="true" />
                        </Dropdown.Toggle>

                        {showStock ?
                          <Dropdown.Menu className="stock-notify-dropdown-menu">
                            {showStock?.length ? showStock.map((item,index) => {
                              return <Dropdown.Item key={index} className="stock-notify-dropdown-list" disabled>
                                <div style={{ fontSize: "13px" }}>
                                  <div className={`stock-notify-dropdown-item stock-items-green`}>
                                    <span className="text-truncate"><strong>Doc:</strong> {item?.document_identity}</span>
                                    <span className="text-preline"><strong>From Branch:</strong> {item?.from_branch_name}</span>
                                  </div>
                                </div>
                              </Dropdown.Item>
                            }) : (
                              <Dropdown.Item className="stock-notify-dropdown-list" disabled>
                                <div style={{ fontSize: "13px" }}>
                                  <div className={`stock-notify-dropdown-item stock-items-green`}>
                                    <span className="text-truncate"><strong>Doc:</strong> {showStock?.document_identity}</span>
                                    <span className="text-preline"><strong>From Branch:</strong> {showStock?.from_branch_name}</span>
                                  </div>
                                </div>
                              </Dropdown.Item>
                            )
                            }                        
                          </Dropdown.Menu>
                         : ""} 
                      </Dropdown>
                    </li>

                    {showNotify && <li className="config-list__item shortcuts">
                      <Dropdown className="stock-notify-dropdown" onToggle={()=>setShowBadge(false)}>
                        {showBadge && <p className="stock-notify-badge">
                          <Badge bg="btn-success">{stock && stock.length}</Badge>
                        </p>}
                        <Dropdown.Toggle variant="transparent" className="custom-toggle" id="dropdown-basic">
                          <i className={`fa fa-bell`} style={{fontSize:"18px",color: "#0a8d6e"}} aria-hidden="true"></i>
                        </Dropdown.Toggle>

                        <Dropdown.Menu className="stock-notify-dropdown-menu">
                          {stock.length > 0 && stock.map((item,index) => {
                            return <Dropdown.Item key={index} className="stock-notify-dropdown-list" disabled>
                              <div style={{ fontSize: "13px" }}>
                                <div className={`stock-notify-dropdown-item ${parseInt(item.stockQty) < 10 ? 'stock-items-red' : 'stock-items-green'}`}>
                                  <span className="text-truncate"><strong>Name:</strong> {item?.iiName}</span>
                                  <span className="text-preline"><strong>Remaining Qty:</strong> {item?.stockQty}</span>
                                </div>
                              </div>
                            </Dropdown.Item>
                          })
                          }                        
                        </Dropdown.Menu>
                      </Dropdown>
                    </li>}

                    <li className="config-list__item shortcuts">
                      <div className="stock-notify-dropdown">
                        <NavLink
                          to="/dashboard/pos/pre-orders"
                          title="pre order"
                        > 
                          {preOrderCount > 0 && <p className="stock-notify-badge">
                            <Badge bg="btn-success">{preOrderCount}</Badge>
                          </p>}
                          {/* <i className="fa fa-shopping-cart xlg-text text-white" style={{fontSize:"18px"}}></i>
                          <i className="fa fa-clock-o sm-text text-white position-absolute" style={{bottom:"3px", right:"3px"}}></i> */}
                            <img src={'/assets/img/pre-order-shortcut-icon.svg'} alt="pre order" style={{width:"29px", height:"29px"}} /> 
                       
                        </NavLink>
                      </div>
                    </li>

                    <li className="config-list__item shortcuts">
                      <NavLink
                        to={"/dashboard"}
                        className="text-capitalize sm-text nav-link pl-2"
                        title="home"
                      > 
                        <img src={'/assets/img/home-icon.svg'} alt="home" style={{width:"24px", height:"24px"}} />
                      </NavLink>
                    </li>
                    <li className="config-list__item shortcuts">
                      <NavLink
                        to={{
                          pathname:"/dashboard/pos",
                        }}
                        className="text-capitalize sm-text nav-link pl-2"
                        title="pos"
                      >
                        {/* <i className="fa fa-cutlery text-primary" style={{fontSize: "20px"}}></i> */}
                        <img src={'/assets/img/pos-shortcut-icon.svg'} alt="pos" style={{width:"24px", height:"24px"}} />
                      </NavLink>
                    </li>
                    
                    {authUserInfo.permissions !== null &&
                      checkPermission(authUserInfo.permissions, "Show Expense List") && authUserInfo.details.user_type !== "waiter" ?
                     <li className="config-list__item shortcuts">
                      <NavLink
                      to={{
                        pathname:"/dashboard/expense",
                        state: {from: history.location.pathname}
                      }}
                      className="text-capitalize sm-text nav-link pl-2"
                      title="expense"
                      >
                      {/* <img
                       height={25}
                       src={Expense} className="text-primary" alt=""/> */}
                      <img src={'/assets/img/expense-shortcut-icon.svg'} alt="expense" style={{width:"24px", height:"24px"}} />
                      
                      </NavLink>
                    </li>:null}

                    {/* <li className="config-list__item">
                      <div className="fk-language d-flex align-items-center">
                        <div
                          className="fk-language__flag"
                          style={{
                            backgroundImage: `${defaultLang && `url(${defaultLang.image})`
                              }`,
                          }}
                        ></div>
                        
                        
                        <div className="dropdown">
                          <a
                            className="text-capitalize sm-text nav-link dropdown-toggle pl-2"
                            href="#"
                            data-toggle="dropdown"
                            aria-expanded="false"
                            rel="noopener noreferrer"
                          >
                            {defaultLang ? defaultLang.name : "Language"}
                          </a>
                          <ul className="dropdown-menu">
                            {navLanguageList &&
                              navLanguageList.map((item, index) => {
                                return (
                                  <li key={index}>
                                    <button
                                      type="button"
                                      className={`dropdown-item sm-text text-capitalize ${defaultLang &&
                                        item.code === defaultLang.code
                                        ? "active"
                                        : ""
                                        }`}
                                      onClick={() => handleDefaultLang(item)}
                                    >
                                      {item.name}
                                    </button>
                                  </li>
                                );
                              })}
                          </ul>
                        </div>
                      </div>
                    </li> */}
                    {
                      // currency
                    }
                    <li className="config-list__item right-space-caret">
                      <div className="d-flex align-items-center">
                        <div
                          className="circle circle--sm rounded-circle border"
                          style={style.currency}
                        >
                          {defaultCurrency ? defaultCurrency.symbol : "$"}
                        </div>
                        <div className="dropdown">
                          <button
                            type="button"
                            className="ml-2 xl-text font-weight-bold nav-link btn dropdown-toggle pl-2"
                            data-toggle="dropdown"
                            aria-expanded="false"
                          >
                            {defaultCurrency
                              ? defaultCurrency.code
                              : "Currency"}
                          </button>
                          <ul className="dropdown-menu mt-1 new-header-currency-dropdown">
                            {navCurrencyList &&
                              navCurrencyList.map((item, index) => {
                                return (
                                  <li key={index}>
                                    <button
                                      type="button"
                                      className={`dropdown-item sm-text text-capitalize ${defaultCurrency &&
                                        item.code === defaultCurrency.code
                                        ? "active"
                                        : ""
                                        }`}
                                      onClick={() =>
                                        handleDefaultCurrency(item)
                                      }
                                    >
                                      {item.name}
                                    </button>
                                  </li>
                                );
                              })}
                          </ul>
                        </div>
                      </div>
                    </li>
                    {(getCookie() === undefined  && !Online(BASE_URL + "/auth/user")) ||
                      (props.location.state &&
                        props.location.state === "loggedOut") ? (
                      <li>
                        <NavLink
                          className="sm-text text-capitalize btn btn-primary"
                          to="/"
                        >
                          {_t(t("Login"))}
                        </NavLink>
                      </li>
                    ) : (
                      <li className="config-list__item border-left-1 right-space-caret">
                        <div className="d-flex align-items-center ">
                           <div className="circle circle--lg rounded-circle ">
                            <img
                              src={
                                authUserInfo.details !== null &&
                                  authUserInfo.details.image !== null
                                  ? [BASE_URL + authUserInfo.details.image]
                                  : "/assets/img/user.jpg"
                              }
                              alt=""
                              className="img-fluid avatar__img"
                            />
                          </div>
                          <div className="dropdown">
                            <button
                              type="button"
                              className="xl-text font-weight-bold text-capitalize sm-text nav-link btn dropdown-toggle pl-2"
                              data-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <span className="text-truncate d-block ml-2" style={{maxWidth:"7rem"}}>
                                {authUserInfo.details !== null &&
                                  authUserInfo.details.name}
                              </span>
                            </button>
                            <ul className="dropdown-menu dropdown-menu-right mt-2 new-header-user-info-dropdown">
                              <li>
                                <Link
                                  to="/dashboard"
                                  className="dropdown-item sm-text text-capitalize"
                                >
                                  {_t(t("Dashboard"))}
                                </Link>
                              </li>
                              {/* {window.location.pathname === "/" ? (
                                <li key={'sdf'}>
                                  <Link
                                    to="/dashboard"
                                    className="dropdown-item sm-text text-capitalize"
                                  >
                                    {_t(t("Dashboard"))}
                                  </Link>
                                </li>
                              ) : (
                                <li>
                                  <Link
                                    to="/dashboard"
                                    className="dropdown-item sm-text text-capitalize"
                                  >
                                    {_t(t("Dashboard"))}
                                  </Link>
                                </li>
                              )} */}
                              

                              {
                                Online(BASE_URL + "/auth/user") &&
                                <>
                                  <li>
                                    <Link
                                      to="/update-user-profile"
                                      className="dropdown-item sm-text"
                                    >
                                      {_t(t("Change password"))}
                                    </Link>
                                  </li>
                                  <hr className="my-1" />
                                  <li>
                                    <button
                                    className="dropdown-item sm-text"
                                    onClick={handleQB}
                                    >
                                      {_t(t("Connect to QB"))}
                                    </button>
                                  </li>
                                  <hr className="my-1" />
                                  {
                                    authUserInfo.details?.user_type === "manager" && (
                                    <> 
                                      <li>
                                        <button
                                          className="dropdown-item sm-text"
                                          onClick={handlePasscode}
                                        >
                                          {_t(t("Manager Passcode"))}
                                        </button>
                                      </li>
                                      <hr className="my-1" />
                                    </> 
                                    )
                                  }
                                  {
                                    (authUserInfo.details?.user_type === "superAdmin" || authUserInfo.details?.user_type === "admin") && (
                                      <>
                                        <li>
                                          <button
                                            className="dropdown-item sm-text text-capitalize"
                                            onClick={handleFlushCache}
                                          >
                                            {_t(t("Flush Cache"))}
                                          </button>
                                        </li>
                                        <hr className="my-1" />
                                      </>  
                                    )
                                  }

                                <li>
                                  <button
                                    className="dropdown-item sm-text text-capitalize"
                                    onClick={handleClearCache}
                                  >
                                    {_t(t("Clear Cache"))}
                                  </button>
                                </li>
                              </>
                              }
                              <hr className="my-1" />
                              <li key={'yyq'}>
                                <button
                                  className="dropdown-item sm-text text-capitalize"
                                  onClick={handleLogout}
                                >
                                  {_t(t("Logout"))}
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </header>
      ) : (
        [
          (props.location.pathname.includes("/dashboard/pos") &&
          props.location.pathname !== "/" &&
          props.location.pathname !== "/profile" &&
          props.location.pathname !== "/my-orders" &&
          !props.location.pathname.startsWith("/digital-menu") &&
          props.location.pathname !== "/delivery-man-registration") ? (
            <header key={2} id="header" className="sticky-top pos-header">
              <div className="container-fluid">
                <div className="row align-items-center">
                  <div className="col-6 col-lg-2">
                    <div className="fk-brand fk-brand--sr-lg">
                      {getCookie() !== undefined || isOnline
                        ? [
                          window.location.pathname === "/dashboard" ? (
                            <NavLink
                              to={{
                                pathname: "/refresh",
                                state: "/dashboard",
                              }}
                              exact
                              className="t-link w-100"
                            >
                              <span
                                className="fk-brand__img fk-brand__img--fk"
                                style={style.logo}
                              ></span>
                            </NavLink>
                          ) : (
                            <NavLink
                              to="/dashboard"
                              exact
                              className="t-link w-100"
                              key="logokey"
                            >
                              <span
                                className="fk-brand__img fk-brand__img--fk"
                                style={style.logo}
                              ></span>
                            </NavLink>
                          ),
                        ]
                        : [
                          window.location.pathname === "/" ? (
                            <NavLink
                              to={{ pathname: "/refresh", state: "/" }}
                              exact
                              className="t-link w-100"
                            >
                              <span
                                className="fk-brand__img fk-brand__img--fk"
                                style={style.logo}
                              ></span>
                            </NavLink>
                          ) : (
                            <NavLink to="/" exact className="t-link w-100">
                              <span
                                className="fk-brand__img fk-brand__img--fk"
                                style={style.logo}
                              ></span>
                            </NavLink>
                          ),
                        ]}
                    </div>
                  </div>

                  <div className="col-6 col-lg-8 col-xl-8 col-xxl-8 ml-lg-auto">
                    <div className="fk-phn-nav text-right d-lg-none">
                      <span className="fk-phn-nav__icon xlg-text">
                        <i className="fa fa-bars"></i>
                      </span>
                    </div>
                    <div className="fk-phn-nav__menu">
                      <ul className="t-list config-list d-flex flex-column flex-sm-row align-items-sm-center flex-wrap justify-content-md-center justify-content-lg-between justify-content-xl-end">

                      <li className="config-list__item shortcuts">
                        <button title="Full screen" className="text-capitalize sm-text nav-link pl-2 bg-transparent border-0" onClick={()=>fullExitScreen()}>
                          {/* {
                            isFullscreen ? <i className="fa fa-compress xxslg-text text-primary"></i>
                            : <i className="fa fa-expand xxslg-text text-primary"></i>
                          } */}

                          
                          {isFullscreen ? <img src={'/assets/img/full-screen-pos-icon.svg'} alt="minimize" style={{width:"24px", height:"24px"}} />
                            : <img src={'/assets/img/full-screen-pos-icon.svg'} alt="maximize" style={{width:"24px", height:"24px"}} />
                          }
                        
                        </button>
                      </li>

                      {blinkConfig.show && <li className="config-list__item shortcuts">
                        <Dropdown className="stock-notify-dropdown" onToggle={(isOpen) => {
                          if(isOpen) fetchBlinkStocks();
                        }}>
                          {blinkConfig.blink && <p className="stock-notify-badge">
                            <Badge bg="warning" text="white">!</Badge>
                          </p>}
                          <Dropdown.Toggle title="Low Stock" variant="transparent" className="custom-toggle" id="dropdown-blink-desktop">
                            <i className={`fa fa-exclamation-triangle ${blinkConfig.blink ? 'modern-icon-blink' : ''}`} style={{fontSize:"20px",color: blinkConfig.blink ? "#e74c3c" : "#0a8d6e"}} aria-hidden="true"></i>
                          </Dropdown.Toggle>

                          <Dropdown.Menu className="stock-notify-dropdown-menu">
                            {blinkStock.data ?
                              Object.keys(blinkStock.data).map((branchName) => {
                                return blinkStock.data[branchName].map((item, index) => (
                                  <Dropdown.Item key={`${branchName}-${index}`} className="stock-notify-dropdown-list" disabled>
                                    <div style={{ fontSize: "13px" }}>
                                      <div className="stock-notify-dropdown-item stock-items-green">
                                        <span className="text-truncate">
                                          <i className="fa fa-info-circle mr-1" style={{ pointerEvents: 'auto', cursor: 'help' }} title="Note: Item quantity is in base quantity" aria-hidden="true"></i>
                                          <strong>Item:</strong> {item.item_name}
                                        </span>
                                        <span className="text-preline"><strong>Stock:</strong> {item.current_stock}</span>
                                        <span className="text-preline"><strong>Min Limit:</strong> {item.min_limit_qty}</span>
                                      </div>
                                    </div>
                                  </Dropdown.Item>
                                ))
                              })
                             : blinkStock.loading ? (
                               <Dropdown.Item disabled>Loading...</Dropdown.Item>
                             ) : <Dropdown.Item disabled>No Data</Dropdown.Item>} 
                          </Dropdown.Menu>
                        </Dropdown>
                      </li>}

                      <li className="config-list__item shortcuts">
                        <Dropdown className="stock-notify-dropdown" onToggle={()=>setShowReqBadge(false)}>
                          {showReqBadge && <p className="stock-notify-badge">
                            <Badge bg="btn-success">{showStock && (Array.isArray(showStock) ? showStock.length : 1)}</Badge>
                          </p>}
                          <Dropdown.Toggle title="Stock request" variant="transparent" className="custom-toggle" id="dropdown-basic">
                            <FaMessage style={{fontSize:"18px",color: "#0a8d6e"}} aria-hidden="true" />
                          </Dropdown.Toggle>

                          {showStock ?
                            <Dropdown.Menu className="stock-notify-dropdown-menu">
                              {showStock?.length ? showStock.map((item,index) => {
                                return <Dropdown.Item key={index} className="stock-notify-dropdown-list" disabled>
                                  <div style={{ fontSize: "13px" }}>
                                    <div className={`stock-notify-dropdown-item stock-items-green`}>
                                      <span className="text-truncate"><strong>Doc:</strong> {item?.document_identity}</span>
                                      <span className="text-preline"><strong>From Branch:</strong> {item?.from_branch_name}</span>
                                    </div>
                                  </div>
                                </Dropdown.Item>
                              }) : (
                                <Dropdown.Item className="stock-notify-dropdown-list" disabled>
                                  <div style={{ fontSize: "13px" }}>
                                    <div className={`stock-notify-dropdown-item stock-items-green`}>
                                      <span className="text-truncate"><strong>Doc:</strong> {showStock?.document_identity}</span>
                                      <span className="text-preline"><strong>From Branch:</strong> {showStock?.from_branch_name}</span>
                                    </div>
                                  </div>
                                </Dropdown.Item>
                              )
                              }                        
                            </Dropdown.Menu>
                          : ""}
                        </Dropdown>
                      </li>

                      {showNotify && <li className="config-list__item shortcuts">
                        <Dropdown className="stock-notify-dropdown" onToggle={()=>setShowBadge(false)}>
                          {showBadge && <p className="stock-notify-badge">
                            <Badge bg="btn-success">{stock && stock.length}</Badge>
                          </p>}
                          <Dropdown.Toggle variant="transparent" className="custom-toggle" id="dropdown-basic">
                            <i className={`fa fa-bell`} style={{fontSize:"18px",color: "#0a8d6e"}} aria-hidden="true"></i>
                          </Dropdown.Toggle>

                          <Dropdown.Menu className="stock-notify-dropdown-menu">
                            {stock.length>0 && stock.map((item,index) => {
                              return <Dropdown.Item key={index} className="stock-notify-dropdown-list" disabled>
                                <div style={{ fontSize: "13px" }}>
                                  <div className={`stock-notify-dropdown-item ${parseInt(item.stockQty) < 10 ? 'stock-items-red' : 'stock-items-green'}`}>
                                    <span className="text-truncate"><strong>Name:</strong> {item?.iiName}</span>
                                    <span><strong>Remaining Qty:</strong> {item?.stockQty}</span>
                                  </div>
                                </div>
                              </Dropdown.Item>
                            })
                            }                        
                          </Dropdown.Menu>
                        </Dropdown>
                      </li>}

                      <li className="config-list__item shortcuts">
                        <div className="stock-notify-dropdown">
                          <NavLink
                            to="/dashboard/pos/pre-orders"
                            // className="dropdown-toggle"
                            title="pre order"
                          > 
                            {preOrderCount > 0 && <p className="stock-notify-badge">
                              <Badge bg="btn-success">{preOrderCount}</Badge>
                            </p>}
                            {/* <i className="fa fa-shopping-cart text-white" style={{fontSize:"18px"}}></i> */}
                            {/* <i className="fa fa-clock-o sm-text text-white position-absolute" style={{bottom:"3px", right:"3px"}}></i> */}
                            <img src={'/assets/img/pre-order-shortcut-icon.svg'} alt="pre order" style={{width:"29px", height:"29px"}} /> 
                          </NavLink>
                        </div>
                      </li>

                      <li className="config-list__item shortcuts">
    
                        <NavLink
                          to={"/dashboard"}
                          className="text-capitalize sm-text nav-link pl-2"
                          title="home"
                        >
                          {/* <i className="fa fa-home xlg-text text-primary"></i> */}
                          <img src={'/assets/img/home-icon.svg'} alt="home" style={{width:"24px", height:"24px"}} />
                        </NavLink>
                      </li>
                      <li className="config-list__item shortcuts">
                        <NavLink
                          to={{
                            pathname:"/dashboard/pos",
                            state: {from: history.location.pathname}
                          }}
                          className="text-capitalize sm-text nav-link pl-2"
                          title="pos"
                        >
                          {/* <i className="fa fa-cutlery text-primary" style={{fontSize: "20px"}}></i> */}
                          <img src={'/assets/img/pos-shortcut-icon.svg'} alt="pos" style={{width:"24px", height:"24px"}} />
                        </NavLink>
                      </li>

                      {authUserInfo.permissions !== null &&
                        checkPermission(authUserInfo.permissions, "Show Expense List") && authUserInfo.details.user_type !== "waiter" ?
                        <li className="config-list__item shortcuts">
                        <NavLink
                        to={{
                          pathname:"/dashboard/expense",
                        }}
                        className="text-capitalize sm-text nav-link pl-2"
                        title="expense"
                        >
                        {/* <img
                        height={25}
                        src={Expense} className="text-primary" alt=""/> */}
                        <img src={'/assets/img/expense-shortcut-icon.svg'} alt="expense" style={{width:"24px", height:"24px"}} />
                        </NavLink>
                      </li>:null}
                        {/* <li className="config-list__item">
                          <div className="fk-language d-flex align-items-center">
                            <div
                              className="fk-language__flag"
                              style={{
                                backgroundImage: `${defaultLang && `url(${defaultLang.image})`
                                  }`,
                              }}
                            ></div>
                            <div className="dropdown">
                              <a
                                className="text-capitalize sm-text nav-link dropdown-toggle pl-2"
                                href="#"
                                data-toggle="dropdown"
                                aria-expanded="false"
                                rel="noopener noreferrer"
                              >
                                {defaultLang ? defaultLang.name : "Language"}
                              </a>
                              <ul className="dropdown-menu">
                                {navLanguageList &&
                                  navLanguageList.map((item, index) => {
                                    return (
                                      <li key={index}>
                                        <button
                                          type="button"
                                          className={`dropdown-item sm-text text-capitalize ${defaultLang &&
                                            item.code === defaultLang.code
                                            ? "active"
                                            : ""
                                            }`}
                                          onClick={() =>
                                            handleDefaultLang(item)
                                          }
                                        >
                                          {item.name}
                                        </button>
                                      </li>
                                    );
                                  })}
                              </ul>
                            </div>
                          </div>
                        </li> */}
                        {
                          // currency
                        }
                        <li className="config-list__item right-space-caret">
                          <div className="d-flex align-items-center">
                            <div
                              className="circle circle--lg rounded-circle border"
                              style={style.currency}
                            >
                              {defaultCurrency ? defaultCurrency.symbol : "$"}
                            </div>
                            <div className="dropdown">
                              <button
                                type="button"
                                className="ml-2 xl-text font-weight-bold nav-link btn dropdown-toggle pl-2"
                                data-toggle="dropdown"
                                aria-expanded="false"
                              >
                                {defaultCurrency
                                  ? defaultCurrency.code
                                  : "Currency"}
                              </button>
                              <ul className="dropdown-menu mt-1 new-header-currency-dropdown">
                                {navCurrencyList &&
                                  navCurrencyList.map((item, index) => {
                                    return (
                                      <li key={index}>
                                        <button
                                          type="button"
                                          className={`dropdown-item sm-text text-capitalize ${defaultCurrency &&
                                            item.code === defaultCurrency.code
                                            ? "active"
                                            : ""
                                            }`}
                                          onClick={() =>
                                            handleDefaultCurrency(item)
                                          }
                                        >
                                          {item.name}
                                        </button>
                                      </li>
                                    );
                                  })}
                              </ul>
                            </div>
                          </div>
                        </li>
                        {(getCookie() === undefined && !Online(BASE_URL + "/auth/user")) ||
                          (props.location.state &&
                            props.location.state === "loggedOut") ? (
                          <li>
                            <NavLink
                              className="sm-text text-capitalize btn btn-primary"
                              to="/"
                            >
                              {_t(t("Login"))}
                            </NavLink>
                          </li>
                          ) : "" }
                        <li className="config-list__item border-left-1 right-space-caret">
                              <div className="d-flex align-items-center"> 
                                  <div className="circle circle--lg rounded-circle ">
                                    <img
                                      src={
                                        authUserInfo.details !== null &&
                                          authUserInfo.details.image !== null
                                          ? [
                                            BASE_URL +
                                            authUserInfo.details.image,
                                          ]
                                          : "/assets/img/user.jpg"
                                      }
                                  alt=""
                                  className="img-fluid avatar__img"
                                />
                              </div> 
                              <div className="dropdown">
                                <button
                                  type="button"
                                  className="xl-text font-weight-bold text-capitalize sm-text nav-link btn dropdown-toggle pl-2"
                                  data-toggle="dropdown"
                                  aria-expanded="false"
                                >
                                  <div className="text-truncate d-flex flex-column ml-2" style={{maxWidth:"7rem"}}>
                                    <span className="text-truncate d-inline-block lh-1">
                                      {authUserInfo.details !== null &&
                                        authUserInfo.details.name}
                                    </span>
                                    <span className="text-truncate d-inline-block sm-text font-weight-normal text-left">
                                      {authUserInfo.details !== null &&
                                        authUserInfo.details?.user_type}
                                    </span>
                                  </div>
                                </button> 
                                <ul className="dropdown-menu dropdown-menu-right mt-2 new-header-user-info-dropdown">
                                  <li>
                                    <Link
                                      to="/dashboard"
                                      className="dropdown-item sm-text text-capitalize"
                                    >
                                      {_t(t("Dashboard"))}
                                    </Link>
                                  </li> 
                                {/* window.location.pathname === "/" ? (
                                    <li>
                                      <Link
                                        to="/dashboard"
                                        className="dropdown-item sm-text text-capitalize"
                                      >
                                        {_t(t("Dashboard"))}
                                      </Link>
                                    </li>
                                  ) : (
                                    <li key="homepage">
                                      <Link
                                        to="/dashboard"
                                        className="dropdown-item sm-text text-capitalize"
                                      >
                                        {_t(t("Dashboard"))}
                                      </Link>
                                    </li>
                                  )} */}
                                  {
                                    Online(BASE_URL + "/auth/user") &&
                                    <>
                                    <li key="homepage">
                                      <Link
                                        to="/update-user-profile"
                                        className="dropdown-item sm-text"
                                      >
                                        {_t(t("Change password"))}
                                      </Link>
                                    </li>
                                    <hr className="my-1" />
                                    <li>
                                      <button
                                      className="dropdown-item sm-text"
                                      onClick={handleQB}
                                      >
                                        {_t(t("Connect to QB"))}
                                      </button>
                                    </li>
                                    <hr className="my-1" />
                                    {
                                      authUserInfo.details?.user_type === "manager" && (
                                        <> 
                                          <li>
                                            <button
                                              className="dropdown-item sm-text"
                                              onClick={handlePasscode}
                                            >
                                              {_t(t("Manager Passcode"))}
                                            </button>
                                          </li>
                                          <hr className="my-1" />
                                        </> 
                                      )
                                    }
                                    {
                                      (authUserInfo.details?.user_type === "superAdmin" || authUserInfo.details?.user_type === "admin") && (
                                        <>
                                          <li>
                                            <button
                                              className="dropdown-item sm-text text-capitalize"
                                              onClick={handleFlushCache}
                                            >
                                              {_t(t("Flush Cache"))}
                                            </button>
                                          </li>
                                          <hr className="my-1" />
                                        </>  
                                      )
                                    }
                                    <li>
                                      <button
                                        className="dropdown-item sm-text text-capitalize"
                                        onClick={handleClearCache}
                                      >
                                        {_t(t("Clear Cache"))}
                                      </button>
                                    </li>
                                    </>
                                  }
                                <hr className="my-1" />
                                <li>
                                  <button
                                    className="dropdown-item sm-text text-capitalize"
                                    onClick={()=>handleLogout()}
                                    rel="noopener noreferrer"
                                  >
                                    {_t(t("Logout"))}
                                  </button>
                                </li> 
                              </ul>
                            </div>
                          </div>
                        </li> 
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="d-md-none d-sm-none">
                  <div className="row">
                    <div className="col-12">
                      <div className="fk-sm-nav" data-simplebar>
                          {foodGroupForSearch &&
                            foodGroupForSearch.map((groupItem, index) => {
                              return (
                                <li key={index}
                                  className={`fk-sm-nav__list ${index === 0 && "active"
                                    }`}
                                >
                                  <a
                                    href={`#card-${index + 1}`}
                                    className="t-link fk-sm-nav__link"
                                    rel="noopener noreferer"
                                  >
                                    {groupItem.name}
                                  </a>
                                </li>
                              );
                            })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </header>
          ) : "",
        ]
      )}

    </>
  );
};

export default withRouter(React.memo(Navbar));
